import {Injectable, Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'ldTextEllipsis'
})
@Injectable()
export class TextEllipsisPipe implements PipeTransform {
  transform (text: string, length: number = 60): string {
    return typeof text === 'undefined' || !text
      ? ''
      : text.length <= length
        ? text
        : text.substring(0, length) + '...'
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/pipes/text-ellipsis.pipe.ts